import * as Yup from 'yup';
import { CHECKOUT_METHOD } from 'constants/checkout';

export const CheckoutFormValidationSchema = Yup.object().shape({
  firstName: Yup.string()
    .max(255, 'You have exceeded the maximum number of 255 characters')
    .required('This field is required'),

  lastName: Yup.string()
    .max(255, 'You have exceeded the maximum number of 255 characters')
    .required('This field is required'),

  email: Yup.string()
    .email('Please, enter valid email address')
    .max(40, 'You have exceeded the maximum number of 40 characters')
    .required('This field is required'),

  storedCreditCard: Yup.object()
    .nullable()
    .when(['method'], (method, schema) =>
      method && method === CHECKOUT_METHOD.STORED_CREDIT_CARD
        ? schema.required('Please, select credit card')
        : schema
    ),

  cardNumber: Yup.string().when(
    ['storedCreditCards', 'method'],
    (storedCreditCards, method, schema) =>
      !method ||
      [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
        method
      ) !== -1
        ? schema
        : schema
            .required('This field is required')
            .test(
              'is-numbers',
              'Card number must contain only numbers',
              value => new RegExp(/^\d+$/).test(value)
            )
  ),

  expirationDate: Yup.object()
    .nullable()
    .when(
      ['storedCreditCards', 'method'],
      (storedCreditCards, method, schema) =>
        !method ||
        [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
          method
        ) !== -1
          ? schema
          : schema
              .test(
                'is-valid-date',
                'This field is required',
                value => value && value.month && value.year
              )
              .test('is-expired', 'Card has expired', value => {
                const date = new Date();
                const year = date.getFullYear();
                const month = date.getMonth();

                return (
                  value &&
                  value.month &&
                  value.year &&
                  !(value.year === year && value.month < month + 1)
                );
              })
    ),

  cardCode: Yup.string().when(
    ['storedCreditCards', 'method'],
    (storedCreditCards, method, schema) =>
      !method ||
      [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
        method
      ) !== -1
        ? schema
        : schema
            .required('This field is required')
            .test(
              'is-numbers',
              'Card Verification Code must contain only numbers',
              value => new RegExp(/^\d+$/).test(value)
            )
            .min(3, 'Card Verification Code too short')
            .max(4, 'Card Verification Code too long')
  ),

  street: Yup.string().when(
    ['storedCreditCards', 'method'],
    (storedCreditCards, method, schema) =>
      !method ||
      [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
        method
      ) !== -1
        ? schema
        : schema.required('This field is required')
  ),

  city: Yup.string().when(
    ['storedCreditCards', 'method'],
    (storedCreditCards, method, schema) =>
      !method ||
      [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
        method
      ) !== -1
        ? schema
        : schema.required('This field is required')
  ),

  state: Yup.string().when(
    ['storedCreditCards', 'method'],
    (storedCreditCards, method, schema) =>
      !method ||
      [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
        method
      ) !== -1
        ? schema
        : schema.required('This field is required')
  ),

  country: Yup.object()
    .nullable()
    .when(
      ['storedCreditCards', 'method'],
      (storedCreditCards, method, schema) =>
        !method ||
        [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
          method
        ) !== -1
          ? schema
          : schema.required('This field is required')
    ),

  postcode: Yup.string().when(
    ['storedCreditCards', 'method'],
    (storedCreditCards, method, schema) =>
      !method ||
      [CHECKOUT_METHOD.PAYPAL, CHECKOUT_METHOD.STORED_CREDIT_CARD].indexOf(
        method
      ) !== -1
        ? schema
        : schema.required('This field is required')
  ),
});
